import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/globals/globals';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftModalService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-modal.service';
import { TeiasoftToasterService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-toaster.service';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

@Component({
  selector: 'app-change-status',
  templateUrl: './change-status.component.html',
  styleUrls: ['./change-status.component.scss']
})
export class ChangeStatusComponent implements OnInit, OnChanges {
  @Input() enquiryNo: string = "";
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() value: string = "";
  @Input() enquiryOfferStatus: string = "";
  @Input() mstOfferStatus: string[] = new Array();
  @Output() closeChageStatusModal: EventEmitter<any> = new EventEmitter();
  @Output() closeAndReload: EventEmitter<any> = new EventEmitter();

  optionsList: SelectOption[] = new Array();
  newStatus: string = "";

  constructor(private globals: Globals, private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService,
    private teiasoftToaster: TeiasoftToasterService, private translate: TranslateService, private teiasoftModalService: TeiasoftModalService) { }
  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["enquiryNo"]) {
      this.enquiryNo = changes["enquiryNo"].currentValue;
    }

    if (changes && changes["value"]) {
      this.value = changes["value"].currentValue;
    }

    if (changes && changes["mstOfferStatus"]) {
      this.mstOfferStatus = new Array();
      this.mstOfferStatus = changes["mstOfferStatus"].currentValue;
      this.optionsList = new Array();
      for (var x = 0; x < this.mstOfferStatus.length; x++) {
        let _item: SelectOption = new SelectOption();
        _item.value = this.mstOfferStatus![x];
        _item.text = this.mstOfferStatus![x];
        this.optionsList.push(_item);
      }
    }
  }

  changeStatus() {
    if (this.newStatus == 'OrderToPlace' && this.enquiryOfferStatus == 'Open') {
      // margin check
      this.teiasoftLoader.start();
      this.backendService.checkEnquiryTotalMargin(this.enquiryNo, 'ChangeMstOfferStatus').subscribe(res => {
        this.teiasoftLoader.stop();
        if (res.isTotalMarginOk) {
          this.changeOfferStatusAndReload();
        }
        else {
          let params = {
            status: this.newStatus,
            enquiryNo: this.enquiryNo
          };
          this.teiasoftModalService.show('confirm', this.translate.instant("enquiryBook.confirmChangeStatus"), this.translate.instant("enquiryBook.confirmMessageMarginCheckFailed"), params, 'confirmChangeStatusEnquiryWithIssues', true);
        }
      });
    }
    else {
      this.changeOfferStatusAndReload();
    }

  }

  changeOfferStatusAndReload() {
    this.teiasoftLoader.start();
    this.backendService.changeMstOfferStatus(this.newStatus, this.enquiryNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      this.closeAndReload.emit('');
    }, (_err) => {
      this.closeAndReload.emit('');
    });
  }

  /* EVENTS */
  onCloseChageStatusModal() {
    this.closeChageStatusModal.emit('');
  }

  onChangeStatusClick() {
    this.changeStatus();
  }

  onSelected(evt: SelectOption) {
    this.newStatus = evt.value;
  }
}
